import { Carousel } from "@fancyapps/ui/dist/carousel/carousel.esm.js";
import "@fancyapps/ui/dist/carousel/carousel.css";
import { Navigation } from "@fancyapps/ui";
//import "@fancyapps/ui/dist/carousel/carousel.umd.js";
const rentalStepsCarousel = document.querySelectorAll(".rental-steps");
if (rentalStepsCarousel.length) {
	rentalStepsCarousel.forEach((carousel) => {
		new Carousel(carousel, {
			Dots: true,
			slidesPerPage: 1,
			Navigation: false,
			infinite: false,
			center: false,
			breakpoints: {
				"(min-width: 1280px)": {
					enabled: false,
				},
			},
		});
	});
}
